var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_807_38151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 4C9 1.791 12.358 0 16.5 0C20.642 0 24 1.791 24 4C24 6.209 20.642 8 16.5 8C12.358 8 9 6.209 9 4ZM16.5 10C15.473 10 14.499 9.885 13.609 9.685C12.25 8.666 10.023 8 7.5 8C3.358 8 0 9.791 0 12C0 14.209 3.358 16 7.5 16C11.642 16 15 14.209 15 12C15 11.971 14.993 11.943 14.992 11.914H15V14C15 16.209 11.642 18 7.5 18C3.358 18 0 16.209 0 14V16C0 18.209 3.358 20 7.5 20C11.642 20 15 18.209 15 16V18C15 20.209 11.642 22 7.5 22C3.358 22 0 20.209 0 18V20C0 22.209 3.358 24 7.5 24C11.642 24 15 22.209 15 20V19.92C15.485 19.972 15.986 20 16.5 20C20.642 20 24 18.209 24 16V14C24 16.119 20.908 17.849 17 17.987V15.987C20.908 15.849 24 14.12 24 12V10C24 12.119 20.908 13.849 17 13.987V11.987C20.908 11.849 24 10.12 24 8V6C24 8.209 20.642 10 16.5 10Z",
    fill: "#F3D266"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_807_38151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.068f2093fdee35102726d2abd77d5963.svg";
export { ForwardRef as ReactComponent };